import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const ConfirmationEmailCircle: React.FC<IconProps> = () => {
  return (
    <svg width="180" height="181" viewBox="0 0 180 181" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M179.251 166.22C183.592 157.628 171.185 114.671 85.1536 114.671C23.0564 114.671 -5.44448 149.832 0.856505 167.652"
        fill="url(#paint0_radial_7456_41720)"
      />
      <mask id="mask0_7456_41720" maskUnits="userSpaceOnUse" x="0" y="114" width="180" height="54">
        <path d="M179.251 166.22C183.592 157.628 171.185 114.671 85.1536 114.671C23.0564 114.671 -5.44448 149.832 0.856505 167.652" fill="white" />
      </mask>
      <g mask="url(#mask0_7456_41720)">
        <ellipse opacity="0.671968" cx="71.8851" cy="138.761" rx="4.73131" ry="2.62801" fill="url(#paint1_linear_7456_41720)" />
        <ellipse opacity="0.729957" cx="120.175" cy="134.749" rx="7.46495" ry="4.09969" fill="url(#paint2_linear_7456_41720)" />
        <ellipse opacity="0.729957" cx="35.2223" cy="123.816" rx="7.46495" ry="4.09969" fill="url(#paint3_linear_7456_41720)" />
      </g>
      <g opacity="0.320685">
        <ellipse cx="139.614" cy="43.0194" rx="5.04673" ry="5.04578" fill="url(#paint4_linear_7456_41720)" />
        <path
          d="M144.208 46.0983C142.77 46.0319 140.89 45.6161 138.963 44.915C137.036 44.2138 135.328 43.3238 134.184 42.4508C133.701 42.0821 133.349 41.7376 133.15 41.4576C133.209 41.4425 133.274 41.4282 133.348 41.4153C133.903 41.3177 134.712 41.3314 135.677 41.4674L136.029 38.9688C133.234 38.5747 131.206 38.9312 130.621 40.5371C129.771 42.8729 133.233 45.5152 138.1 47.2862C142.967 49.0572 147.318 49.2582 148.168 46.9226C148.764 45.2846 147.458 43.9905 144.685 42.274L143.357 44.4196C144.3 45.0035 145.005 45.5193 145.433 45.944C145.463 45.9737 145.491 46.0024 145.518 46.0301C145.192 46.0968 144.745 46.1232 144.208 46.0983Z"
          fill="url(#paint5_linear_7456_41720)"
        />
        <path
          d="M144.67 43.0194C144.67 40.2327 142.411 37.9736 139.624 37.9736C136.837 37.9736 135.091 39.7553 134.73 41.7643C134.73 41.7643 137.632 43.5804 138.971 43.9708C139.398 44.0953 139.822 44.2568 140.253 44.4C140.736 44.5601 141.227 44.7014 141.724 44.8239C142.064 44.9078 142.53 45.0374 142.966 45.1183C143.54 45.2251 144.054 45.2728 144.094 45.2728C144.166 45.2728 144.244 44.9555 144.404 44.5858C144.565 44.2161 144.67 43.0194 144.67 43.0194Z"
          fill="url(#paint6_linear_7456_41720)"
        />
      </g>
      <circle opacity="0.418364" cx="28.7308" cy="72.786" r="5.88462" fill="url(#paint7_linear_7456_41720)" />
      <ellipse opacity="0.425921" cx="92.4229" cy="122.978" rx="17.6538" ry="4.84615" fill="url(#paint8_linear_7456_41720)" />
      <path
        d="M80.2377 95.2861C80.2377 95.2861 79.7542 96.6859 79.7542 97.6701C79.2708 106.239 80.4691 120.209 80.4691 120.209H82.3302L85.0772 99.1882L88.8008 120.209H90.6317C90.6317 120.209 90.8735 106.715 90.1483 97.6701C90.1483 96.6962 89.7266 95.7623 89.7266 95.7623L80.2377 95.2861Z"
        fill="url(#paint9_linear_7456_41720)"
      />
      <path
        d="M78.6004 84.4401L74.911 85.3131L73.652 84.9786L65.6539 83.8171L63.7226 83.8171L63.715 81.2605L64.1914 82.2421L65.0487 82.5114C65.0487 82.5114 65.5109 81.5781 65.6539 81.7373C65.7969 81.8965 65.8589 82.5523 65.8589 82.5523L66.5736 82.9222L75.0884 82.9222L77.1004 81.7401L78.6004 84.4401Z"
        fill="#FDE7E6"
      />
      <path
        d="M90.6003 84.4401L94.4 85.3131L95.6591 84.9786L103.657 83.8171L105.846 82.7015L106.589 81.2164L106.311 81.177L105.12 82.2421L104.262 82.5114C104.262 82.5114 103.8 81.5781 103.657 81.7373C103.514 81.8965 103.452 82.5523 103.452 82.5523L102.738 82.9222L94.2226 82.9222L92.1003 81.7401L90.6003 84.4401Z"
        fill="#FDE7E6"
      />
      <path
        d="M92.7695 81.8962L91.5987 84.747H88.7361L90.0003 96.5879C90.0003 96.5879 86.3903 97.1945 84.4814 97.3417C82.5726 97.4888 79.8566 96.5879 79.8566 96.5879C79.8566 96.5879 79.8566 92.4591 79.8566 85.0487L77.3148 84.747L76.8465 81.8962C76.8465 81.8962 79.2204 80.2296 79.8566 79.9526C80.4927 79.6756 82.6428 79.3623 82.6428 79.3623L86.0442 79.3623C86.0442 79.3623 88.7462 79.4667 89.2571 79.9526C89.768 80.4385 92.7695 81.8962 92.7695 81.8962Z"
        fill="url(#paint10_linear_7456_41720)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.8128 77.2852H83.6826V80.1121H85.8128V77.2852ZM84.5347 81.7305C84.5347 81.3291 83.6826 80.1126 83.6826 80.1126H85.8128C85.8128 80.1126 84.5347 82.1318 84.5347 81.7305Z"
        fill="#FECECD"
      />
      <ellipse cx="84.6474" cy="76.4248" rx="2.24208" ry="3.17774" fill="#FFE9E9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.1861 76.6308C82.3655 76.0317 82.3655 74.7103 82.7242 74.6672C83.0829 74.6241 83.8004 74.8743 84.5179 74.3889C84.8766 74.1224 85.056 74.089 85.056 73.9552C86.8496 74.2741 85.7769 75.2363 86.6703 76.2964C86.7634 76.4069 87.029 76.2964 87.029 76.2964C87.029 76.2964 87.029 73.6864 86.8496 73.4535C86.6703 73.2207 85.9528 72.2829 85.5941 72.9518C85.5941 72.6174 84.8766 72.2723 84.1591 72.5285C83.4417 72.7846 82.3655 73.2863 82.1861 73.9552C82.0068 74.6241 81.8274 75.9619 82.1861 76.6308Z"
        fill="#513450"
      />
      <path
        d="M80.6119 120.209L80.114 121.057C79.7874 121.612 79.6152 122.245 79.6152 122.89C79.6152 122.939 79.6548 122.978 79.7035 122.978H82.0181C82.2204 122.978 82.3845 122.814 82.3845 122.612C82.3845 121.939 82.2608 121.271 82.0197 120.643L81.8531 120.209H80.6119Z"
        fill="#677285"
      />
      <path
        d="M90.3881 120.209L90.886 121.057C91.2126 121.612 91.3848 122.245 91.3848 122.89C91.3848 122.939 91.3452 122.978 91.2965 122.978H88.9819C88.7796 122.978 88.6155 122.814 88.6155 122.612C88.6155 121.939 88.7392 121.271 88.9803 120.643L89.1469 120.209H90.3881Z"
        fill="#677285"
      />
      <path
        d="M63.7227 16.2148H65.7996V121.792C65.7996 122.365 65.3346 122.83 64.7611 122.83C64.1876 122.83 63.7227 122.365 63.7227 121.792V16.2148Z"
        fill="#D8D8D8"
      />
      <path
        d="M63.6924 16.2772L76.4359 19.3083C81.1302 20.4248 86.0759 19.6248 90.1788 17.0853C95.9676 13.5022 103.048 12.673 109.508 14.8215L113.885 16.2772L110.423 42.1783L109.449 41.7807C103.18 39.2231 96.0226 40.216 90.6871 44.3833C86.4173 47.7183 80.6752 48.4768 75.6858 46.3647L63.6924 41.2878V16.2772Z"
        fill="#4CAF50"
      />
      <path
        d="M94.4245 22.3508C95.1152 21.5674 96.3045 21.5051 97.0733 22.212C97.8338 22.9112 97.8961 24.1004 97.2129 24.8754L85.8059 37.8127C85.4707 38.193 85.0048 38.4151 84.5108 38.441C84.0168 38.4669 83.5303 38.2947 83.1572 37.9515L76.4778 31.8103C75.7173 31.111 75.655 29.9218 76.3382 29.1469C77.029 28.3635 78.2182 28.3012 78.987 29.008L84.2711 33.8664L94.4245 22.3508Z"
        fill="white"
      />
      <mask id="mask1_7456_41720" maskUnits="userSpaceOnUse" x="75" y="21" width="23" height="18">
        <path
          d="M94.4245 22.3508C95.1152 21.5674 96.3045 21.5051 97.0733 22.212C97.8338 22.9112 97.8961 24.1004 97.2129 24.8754L85.8059 37.8127C85.4707 38.193 85.0048 38.4151 84.5108 38.441C84.0168 38.4669 83.5303 38.2947 83.1572 37.9515L76.4778 31.8103C75.7173 31.111 75.655 29.9218 76.3382 29.1469C77.029 28.3635 78.2182 28.3012 78.987 29.008L84.2711 33.8664L94.4245 22.3508Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_7456_41720)">
        <path opacity="0.8" d="M84.3561 33.7566L79.925 38.495L75.0771 35.2828L81.9922 28.3344L84.3561 33.7566Z" fill="url(#paint11_linear_7456_41720)" />
      </g>
      <path
        d="M63.2769 81.8289C63.2769 81.8289 64.3153 81.3096 64.3153 81.4827C64.3153 81.6558 64.3153 83.5596 64.3153 83.5596L63.623 83.9058L63.2769 81.8289Z"
        fill="#FFE9E9"
      />
      <defs>
        <radialGradient
          id="paint0_radial_7456_41720"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(78.0666 133.045) rotate(-90) scale(30.8042 321.719)"
        >
          <stop stopColor="#EBEDF0" stopOpacity="0.24" />
          <stop offset="0.536775" stopColor="#EBEDF0" stopOpacity="0.845525" />
          <stop offset="1" stopColor="#E0E4E7" stopOpacity="0.01" />
        </radialGradient>
        <linearGradient id="paint1_linear_7456_41720" x1="68.0768" y1="138.064" x2="69.5182" y2="141.147" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E1E7EA" />
          <stop offset="1" stopColor="#D0D6DC" />
        </linearGradient>
        <linearGradient id="paint2_linear_7456_41720" x1="113.907" y1="134.366" x2="116.545" y2="139.867" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E1E7EA" />
          <stop offset="1" stopColor="#D0D6DC" />
        </linearGradient>
        <linearGradient id="paint3_linear_7456_41720" x1="30.4625" y1="123.883" x2="31.9549" y2="129.828" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FBFBFB" />
          <stop offset="1" stopColor="#D9DFE3" />
        </linearGradient>
        <linearGradient id="paint4_linear_7456_41720" x1="132.72" y1="39.5449" x2="135.243" y2="48.269" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ECECEC" />
          <stop offset="0.717538" stopColor="#E1E7EA" />
          <stop offset="1" stopColor="#BCC3CA" />
        </linearGradient>
        <linearGradient id="paint5_linear_7456_41720" x1="134.86" y1="44.9915" x2="147.232" y2="49.4946" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BAC6D2" />
          <stop offset="1" stopColor="#7F8F9F" />
        </linearGradient>
        <linearGradient id="paint6_linear_7456_41720" x1="137.757" y1="42.5852" x2="139.408" y2="45.919" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E1E7EA" />
          <stop offset="1" stopColor="#D0D6DC" />
        </linearGradient>
        <linearGradient id="paint7_linear_7456_41720" x1="36.4671" y1="74.5326" x2="30.5911" y2="64.609" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DAE2E6" />
          <stop offset="0.58" stopColor="#E3EBEF" />
          <stop offset="1" stopColor="#EDF6F9" />
        </linearGradient>
        <linearGradient id="paint8_linear_7456_41720" x1="79.1717" y1="123.552" x2="89.0875" y2="138.978" gradientUnits="userSpaceOnUse">
          <stop stopColor="#C4CDD1" />
          <stop offset="1" stopColor="#C6CFD3" stopOpacity="0.01" />
        </linearGradient>
        <linearGradient id="paint9_linear_7456_41720" x1="79.6152" y1="95.2861" x2="93.9142" y2="97.2969" gradientUnits="userSpaceOnUse">
          <stop stopColor="#722082" />
          <stop offset="1" stopColor="#391041" />
        </linearGradient>
        <linearGradient id="paint10_linear_7456_41720" x1="100.825" y1="87.581" x2="85.5008" y2="105.108" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E5E9F0" />
          <stop offset="1" stopColor="#D2DAE8" />
        </linearGradient>
        <linearGradient id="paint11_linear_7456_41720" x1="77.2962" y1="33.526" x2="81.778" y2="36.6876" gradientUnits="userSpaceOnUse">
          <stop stopColor="#67D666" stopOpacity="0.01" />
          <stop offset="1" stopColor="#67D666" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ConfirmationEmailCircle;
